import * as React from 'react';
import { connect } from 'react-redux';
import { getVehicleType } from '../../redux/actions/vehicleTypes';

import {
  IconButton,
  HeadingSection,
  NoteList,
  Permission,
  RouteWrapper,
  VehicleTypeUpdateForm,
  Section,
} from '../../components';

interface Props {
  vehicleTypes: any;
  isFetching: boolean;
  error: any;
  match: any;
  dispatch: Function;
}

interface State {
  id: number;
  vehicleType: any;
  ready: boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    const id = parseInt(this.props.match.params.id, 10);
    this.state = {
      id,
      vehicleType: false,
      ready: false,
    };
  }

  async componentDidMount() {
    const response = await this.props.dispatch(getVehicleType(this.state.id));
    this.setState({
      vehicleType: response.data,
      ready: true,
    });
  }

  render() {
    return (
      <RouteWrapper
        title={this.state.vehicleType.name}
        requireAuth
        requirePermission="MANAGE_VEHICLE_TYPES"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/vehicles', text: 'Vehicles' },
          { link: '/settings/vehicles/types', text: 'Types' },
          {
            link: '/settings/vehicles/types/:id',
            text: this.state.vehicleType.name || 'Type',
          },
        ]}
        loading={this.props.isFetching}
        error={!this.state.ready && this.props.error}
        ready={this.state.ready}
      >
        <HeadingSection
          title={this.state.vehicleType.name}
          image={
            <span className="avatar image is-64x64">
              <img
                src={this.state.vehicleType.image}
                alt={this.state.vehicleType.name}
              />
            </span>
          }
          controls={[
            <Permission key="delete" require="MANAGE_DELETIONS">
              <IconButton
                link={`/settings/vehicles/types/${this.state.id}/delete`}
                className="is-danger"
                icon="trash"
              >
                Delete
              </IconButton>
            </Permission>,
          ]}
        />
        <Section>
          <div className="columns">
            <div className="column is-12-desktop is-7-widescreen">
              <VehicleTypeUpdateForm
                id={this.state.id}
                item={this.state.vehicleType}
                onUpdate={() => {
                  window.history.back();
                }}
              />
            </div>
            <div className="column is-12-desktop is-5-widescreen">
              <NoteList resource="vehicle_types" id={this.state.id} />
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ vehicleTypes }) => ({
  vehicleTypes: vehicleTypes.vehicleTypes,
  error: vehicleTypes.error,
  isFetching: vehicleTypes.isFetching,
});

export default connect(mapStateToProps)(Route);
